<template>
  <v-app-bar
    app
    flat
    elevate-on-scroll
    outlined
    class="qmkey-app-bar"
    color="white"
  >
    <v-toolbar flat color="white" outlined class="qmkey-navigation-toolbar">
      <v-toolbar-items class="qmkey-toolbar-navigation-items" v-if="!isUser">
        <!-- Not loged user -->
        <v-btn 
          v-if="!isUser" 
          text 
          tile 
          to="about"
          active-class="qmkey-toolbar-navigation-item-active"
        >
          <span class="guest-menu">About</span>
        </v-btn>
        <v-btn  
          v-if="!isUser" 
          text 
          tile 
          to="login"
          active-class="qmkey-toolbar-navigation-item-active"
        >
          <span class="guest-menu">Login</span>
        </v-btn>
        <!-- /Not loged user -->
      </v-toolbar-items>
      <!-- Identificated user -->
      <v-toolbar-items v-else >
        <!-- Site Selector -->
        <v-menu 
          offset-y 
          open-on-hover
          close-on-content-click
          content-class="qmkey-toolbar-menu-contents"
          dense
        >
          <template v-slot:activator="{ on, attrs }">
            <v-img
              ref = "current_logo"
              class="mt-1"
              :src="currentSiteLogo"
              height=3.5em
              max-width="150px"
              contain
              v-bind="attrs"
              v-on="on"
              @error="replaceByDefault"
            ></v-img>
          </template>
          <v-list dense class="">
            <v-list-item
              v-for="site in allSites"
              :key="site.id"
              :input-value="site.path == sitePath"
              @click.stop="setSite(site.path)"
              dense
              active-class="qmkey-toolbar-menu-item-active"
            >
              <SiteMenuItem :site="site" />
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- /Site Selector -->
        <!-- Admin menu -->
        <v-menu 
          offset-y 
          max-width="300px" 
          v-if="isManager || isAdmin" 
          open-on-hover
          close-on-content-click
          content-class="qmkey-toolbar-menu-contents"
          dense
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text color="#404040" 
              v-bind="attrs" 
              v-on="on" 
              position="left center"
              :class="'qmkey-toolbar-navigation-items' + (current_menu_tab == 'Admin' ? '-active' : '')"
            >
              Admin
            </v-btn>
          </template>
          <v-list dense class="qmkey-toolbar-menu-contents">
            <v-list-item 
              v-if="isAdmin" 
              @click="goToMenu('Admin', 'sites', 'Sites')"
              :input-value="$route.name == 'sites'"
              active-class="qmkey-toolbar-menu-item-active"
            >
              <v-list-item-title>Sites</v-list-item-title>
            </v-list-item>
            <v-list-item 
              @click="goToMenu('Admin', 'users','Users')"
              :input-value="$route.name == 'users'"
              active-class="qmkey-toolbar-menu-item-active"
            >
              <v-list-item-title>Users</v-list-item-title>
            </v-list-item>
            <v-list-item 
              @click="goToMenu('Admin', 'menus', 'Menus')"
              :input-value="$route.name == 'menus'"
              active-class="qmkey-toolbar-menu-item-active"
            >
              <v-list-item-title>Menus</v-list-item-title>
            </v-list-item>
            <v-list-item 
              @click="goToMenu('Admin', 'vocabularies', 'Vocabulary')"
              :input-value="$route.name == 'vocabularies'"
              active-class="qmkey-toolbar-menu-item-active"
            >
              <v-list-item-title>Vocabulary</v-list-item-title>
            </v-list-item>
            <v-list-item 
              @click="goToMenu('Admin', 'bpexplorertable','BPExplorerTable')"
              :input-value="$route.name == 'bpexplorertable'"
              active-class="qmkey-toolbar-menu-item-active"
            >
              <v-list-item-title>BPExplorer</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- /Admin menu -->
        <!-- App Menus -->
        <v-menu 
          offset-y 
          max-width="300px"
          v-for="menu in menus" 
          v-bind:key="menu.name" 
          open-on-hover
          close-on-click
          content-class="qmkey-toolbar-menu-contents"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text color="#404040"
              v-bind="attrs"
              v-on="on"
              position="left center"
              :class="'qmkey-toolbar-navigation-items' + (current_menu_tab == menu.name ? '-active' : '')"
            >
              {{menu.name}}
            </v-btn>            
          </template>
          <v-list 
            v-for="menuitem in menu.items" 
            v-bind:key="menuitem.name" 
            dense
            :subheader="!menuitem.url"
            class="qmkey-toolbar-menu-contents pt-0 pb-0"
          >
            <v-list-item 
              v-if="menuitem.url"
              @click="goToMenu(menu.name, menuitem.url, menu.name, menuitem.name)"
              :input-value="current_option_menu === menuitem.url"
              active-class="qmkey-toolbar-menu-item-active"
            >
              <v-list-item-title>{{ menuitem.name}}</v-list-item-title>
            </v-list-item>
            <v-subheader 
              class="grey--text text--darken-4" 
              v-if="!menuitem.url"
            >
              {{menuitem.name}}
            </v-subheader>
            <v-list-item 
              v-for="menuitemitem in menuitem.items" 
              :disabled="!menuitemitem.url"
              v-bind:key="menuitemitem.name" 
              color="#F1F1F1"
              style="margin-left:5%" 
              @click="goToMenu(menu.name, menuitemitem.url, menu.name, menuitem.name, menuitemitem.name)">
              <v-list-item-title>{{menuitemitem.name}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- /App Menus -->        
      </v-toolbar-items>
    </v-toolbar>
    <v-row dense>
      <!-- Global Search -->
      <v-spacer>
    </v-spacer>
      <v-col 
        class="mb-0 mt-4 pb-0 d-flex justify-end eader-searchable-text"
        v-if="isUser"
      >
        <SearchText @input="setSearchText"/>
      </v-col>
      <!-- /Global Search -->
      <!-- Notifications -->
      <v-col class="mb-0 mt-3 pb-0 d-flex justify-end" md="auto">
        <NotificationsDialog v-if="isUser"/>
      </v-col>
      <!-- /Notifications -->      
      <!-- User menu -->
      <v-col 
        class="mt-4 mb-0 pb-0 mr-2 d-flex justify-end"
         md="auto"
        >
        <v-menu 
          offset-y 
          open-on-hover
          v-if="isUser"
          close-on-content-click
          content-class="qmkey-toolbar-menu-contents"
          dense
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              v-bind="attrs"
              v-on="on"
              icon
              small
            >
              <v-avatar
                size="36px"              
              >
                <img
                  :src="getUserAvatar()"
                  class="username-picture"
                />
              </v-avatar>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item>
              <v-list-item-title>
                Usuario {{ user.first_name }} {{ user.last_name }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item to="todoList">
              <v-list-item-title>TodoList</v-list-item-title>
            </v-list-item>
            <v-list-item to="preferences">
              <v-list-item-title >Preferencias</v-list-item-title>
            </v-list-item>
            <v-list-item to="logout">
              <v-list-item-content>
                <v-list-item-title>Signout</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <!-- /User menu -->      
      <!-- /Identificated user -->
      <v-col class="d-flex justify-end mt-2 mb-0 pb-0" cols="2">
        <!-- All users QM LOGO-->
        <div class="product-logo-wrapper">
          <v-img
            :src="currentProductLogo()"
            class="product-logo"
            contain
          >
          </v-img>
        </div>
      </v-col>
    </v-row>
  </v-app-bar> 
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import ProcessMenuItem from '@/components/header/ProcessMenuItem'
import SiteMenuItem from '@/components/header/SiteMenuItem'
import NotificationsDialog from '@/components/header/NotificationsDialog'
import SearchText from '@/components/SearchText'
import customThemes from '@/plugins/themes.js'

export default {
  name: 'HeaderMenu',
  data() {
    return {
      explorer_button: 0,
      error_message: '',
      menu_context: '',
      filter_fields_to_collect: [],
      filter_form_error_message: '',
      jsData: '',
      search: '',
      loading: false,
      message:'',
      current_option_menu: '',
      current_process_name: 'Procesos',
      current_menu_tab: '',
      failed_logo: false,
    }
  },
  components: {
    SiteMenuItem,
    ProcessMenuItem,
    NotificationsDialog,
    SearchText,
  },
  computed: {
    currentSiteName() {
      if (this.allSites) {
        const currentSite = this.allSites.filter(
          site => site.path === this.sitePath,
        )
        if (currentSite.length > 0) return currentSite[0].name
      }
      return 'Root'
    },
    currentSiteLogo: function(){
      let logo = require('./assets/logo_earcon.gif')
      if (this.allSites) {
        const currentSite = this.allSites.filter(
          site => site.path === this.sitePath,
        )
        if (currentSite.length > 0 && currentSite[0].logo) {
          logo = currentSite[0].logo
        }
      }
      return this.failed_logo ? require('../../assets/image_not_found.png') : logo
    },
    ...mapGetters(['isUser', 'isManager', 'isAdmin']),
    ...mapState([
      'menus',
      'sitePath',
      'allSites',
      'user',
      'processID',
      'filteredProcesses',
      'current_business_process',
      'searchText', 
      'filtersFormData', 'notifications', 'notifications_count']),
  },
  mounted: function() {
    this.REFRESH_STATE(this)
  },
  updated: function() {
    if (this.jsdata) {
      var jsscript = document.createElement('script')
      jsscript.innerText = this.jsdata
      document.head.appendChild(jsscript)
    }    
  },
  methods: {
    goToMenu(menu_tab, url, name1, name2, name3) {
      // Prevent duplicated navigation
      if (url != this.$router.currentRoute.fullPath){
        this.current_menu_tab = menu_tab;
        this.$router.push(url)
        this.current_option_menu = url
        this.SET_BUSINESS_PROCESS(this.$route.query.business_process)
        this.menu_context = name1;
        if (name2)
          this.menu_context = name2;
        if (name3)
          this.menu_context += ' / ' + name3;
        this.SET_CONTEXT_TITLE(this.menu_context)
      }
    },
    goToExplorer(view_name, button){
      this.SET_CURRENT_VIEW(view_name)
      this.explorer_button = button
    },
    setSite(path) {
      this.failed_logo = false
      this.$session.set('site', path)
      this.SET_CURRENT_SITE(path)
      this.REFRESH_STATE(this)
      this.$router.go()
    },
    ...mapActions(['GET_SITES', 'REFRESH_STATE', 'EXPLORE_UNITS']),
    ...mapMutations([
      'SET_USER',
      'SET_CURRENT_SITE',
      'SET_CURRENT_STANDARD',
      'SET_CURRENT_PROCESS',
      'SET_BUSINESS_PROCESS',
      'SET_SEARCH_TEXT',
      'SET_FILTER_FORM',
      'SET_CONTEXT_TITLE',
      'SET_CURRENT_VIEW',
      'SET_CURRENT_USER_NOTIFICATIONS',
    ]),

    // currentSiteLogo(){
      // if (this.allSites) {
      //   const currentSite = this.allSites.filter(
      //     site => site.path === this.sitePath,
      //   )
      //   if (currentSite.length > 0 && currentSite[0].logo) {
      //     console.log('currentSite', currentSite[0])
      //     this.current_logo = currentSite[0].logo
      //   }
      // }
      // this.current_logo = require('./assets/logo_earcon.gif')
    // },

    currentProductLogo() {
      let logo = customThemes.logo;
      if (this.allSites) {
        const currentSite = this.allSites.filter(
          site => site.path === this.sitePath,
        )
        const product = ((currentSite[0] || {}).qmkey_product || "").toLowerCase();
        if (product && customThemes[product]) {
          logo = customThemes[product].logo;
        }
      }
      return logo;
    },

    getUserAvatar(){
      //TODO:
      if (this.user.photo) return this.user.photo
      return "/foto.gif"
    },
    setSearchText(search_text) {
      this.SET_SEARCH_TEXT(search_text)
      if (this.current_business_process){
        this.EXPLORE_UNITS({
          site: this.sitePath,
          bp_reference: this.current_business_process,
          process_id: this.processID,
          search_text: search_text,
          filters_form: this.filtersFormData,
          units_page: 1,
        })
      }
    },
    replaceByDefault() {
      // e.target.src = require('./assets/logo_earcon.gif')
      // this.current_logo = require('../../assets/image_not_found.png')
      // e.target.src = require('../../assets/image_not_found.png')
      this.failed_logo = true;
    }
  },
 }
</script>


<style lang="scss">
    @import "@/sass/header.scss";
</style>
